module.exports = __webpack_public_path__ + "img/robot-ai.6f1593a8.svg";